export default function Footer() {
  return (
    <footer className="bg-gray-100 text-center text-sm text-gray-600 py-4 mt-4">
        © {new Date().getFullYear()} Earthprint • Built for a cleaner tomorrow 💚
      </footer>
  );
}